import { render, staticRenderFns } from "./PastProjectListItem.vue?vue&type=template&id=275386ee&"
import script from "./PastProjectListItem.vue?vue&type=script&lang=ts&"
export * from "./PastProjectListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports